import {Box} from '@mui/material'
import {useSelector} from 'react-redux'
import ContactForm from './components/ContactForm'
import './index.scss'

const ContactUs = () => {
    const loginDetails = useSelector((state: any) => state.login.loginDetails?.securityParams)

    return (
        <Box
            className={`contact-us__container ${
                !loginDetails || localStorage.getItem('isLoggedIn') !== 'true' ? 'header-spacing' : ''
            }`}
        >
            <div className='background-img' />
            <ContactForm />
        </Box>
    )
}

export default ContactUs
